import { useMemo } from 'react'

export const useNormalizeBlockContent = (content, containerSize) => {
  return useMemo(() => {
    if (!content) return []

    const objectHeights = content.reduce((acc, object) => {
      const height = object.size.rows + (object.cords?.y ?? 0)
      return Math.max(acc, height)
    }, 0)
    const objectWidths = content.reduce((acc, object) => {
      const height = object.size.cols + (object.cords?.x ?? 0)
      return Math.max(acc, height)
    }, 0)

    const sizeDifferences = {
      rows: containerSize.rows - objectHeights,
      cols: containerSize.cols - objectWidths
    }
    if (sizeDifferences.rows > 0 || sizeDifferences.cols > 0) {
      const sortedContent = content.sort((a, b) => {
        const areaA = (a.size.rows + (a.cords?.y ?? 0)) * (a.size.cols + (a.cords?.x ?? 0))
        const areaB = (b.size.rows + (b.cords?.y ?? 0)) * (b.size.cols + (b.cords?.x ?? 0))
        return areaB - areaA
      })

      return sortedContent.map((object, index) => {
        if (sizeDifferences.rows <= 0 && sizeDifferences.cols <= 0) return object

        if (object.cords?.y < sortedContent[0].cords?.y) return object

        if (index > 0) {
          return {
            ...object,
            cords: {
              x: object.cords.x + sizeDifferences.cols,
              y: object.cords.y + sizeDifferences.rows
            }
          }
        }
        return {
          ...object,
          size: {
            cols: object.size.cols + sizeDifferences.cols,
            rows: object.size.rows + sizeDifferences.rows
          }
        }
      })
    }

    return content.map(reportObject => ({
      ...reportObject
    }))
  }, [content, containerSize])
}
